/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/199-upload2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 14h16v1H0zm16-2v1H0v-1l2-4h4v2h4V8h4zM3.5 5L8 .5 12.5 5H9v4H7V5z"/>'
  }
})
